<template>
    <div>
        <div>
            <div class="page-wrapper">
                <div class="page-body">
                    <div class="row g-2">
                        <div class="col">
                            <div class="card">
                                <div class="card-header">
                                    <div class="col">
                                        <h3 class="card-title">
                                            <i class="ti ti-alert-triangle"></i>
                                            Regras de alerta
                                        </h3>
                                    </div>
                                    <div class="col-auto">
                                        <a
                                            href="/alert-rules/new"
                                            class="btn btn-primary"
                                        >
                                            <i class="ti ti-plus"></i>
                                            Criar regra de alerta
                                        </a>
                                    </div>
                                </div>

                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-3 mb-2">
                                            <input
                                                v-model="filter.query"
                                                type="text"
                                                class="form-control"
                                                placeholder="Buscar regras de alerta"
                                                @change="updateFilter"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div v-if="alertRulesList.length" class="table">
                                    <table
                                        class="table table-vcenter card-table"
                                    >
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Grupo</th>
                                                <th>Tipo</th>
                                                <th>Janela de captura</th>
                                                <th>Ação</th>
                                                <th>Status</th>
                                                <th>Atualização</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="alertRule in alertRulesList"
                                                :key="alertRule._id"
                                            >
                                                <td>
                                                    {{ alertRule.name }}
                                                </td>
                                                <td>
                                                    <span
                                                        v-if="
                                                            !groupName(
                                                                alertRule.group
                                                            )
                                                        "
                                                        class="badge bg-gray-lt text-muted"
                                                        >Sem grupo</span
                                                    >
                                                    <span
                                                        v-else
                                                        class="badge bg-blue-lt"
                                                        >{{
                                                            groupName(
                                                                alertRule.group
                                                            )
                                                        }}</span
                                                    >
                                                </td>
                                                <td>
                                                    {{
                                                        getTypeLabel(
                                                            alertRule.type
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        getTimeWindowLabel(
                                                            alertRule.timewindow_seconds
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        getActionLabel(
                                                            alertRule.action
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    <span
                                                        v-if="alertRule.enabled"
                                                        class="badge bg-green text-green-fg"
                                                        >Ativo</span
                                                    >
                                                    <span
                                                        v-else
                                                        class="badge bg-red text-red-fg"
                                                        >Inativo</span
                                                    >
                                                </td>
                                                <td>
                                                    {{
                                                        formatDate(
                                                            alertRule.updated_at
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    <span class="dropdown">
                                                        <button
                                                            class="btn btn-sm dropdown-toggle"
                                                            data-bs-toggle="dropdown"
                                                        >
                                                            Opções
                                                        </button>
                                                        <div
                                                            class="dropdown-menu"
                                                        >
                                                            <a
                                                                :href="
                                                                    '/alert-rules/edit/' +
                                                                    alertRule._id
                                                                "
                                                                class="dropdown-item"
                                                            >
                                                                <i
                                                                    class="ti ti-pencil"
                                                                ></i>
                                                                Editar
                                                            </a>
                                                            <a
                                                                href="#"
                                                                class="dropdown-item"
                                                                @click="
                                                                    (e) => {
                                                                        duplicateAlertRule(
                                                                            e,
                                                                            alertRule
                                                                        )
                                                                    }
                                                                "
                                                            >
                                                                <i
                                                                    class="ti ti-copy"
                                                                ></i>
                                                                Duplicar regra
                                                            </a>
                                                            <a
                                                                :href="
                                                                    '/alert-rules/delete/' +
                                                                    alertRule._id
                                                                "
                                                                class="dropdown-item bg-danger-lt"
                                                            >
                                                                <i
                                                                    class="ti ti-trash"
                                                                ></i>
                                                                Remover
                                                            </a>
                                                        </div>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div
                                    v-if="
                                        !alertRulesList.length && !filter.query
                                    "
                                    class="card-body"
                                >
                                    <div class="empty">
                                        <p class="empty-title">
                                            Nenhuma regra de alerta criado
                                            ainda.
                                        </p>
                                        <p class="empty-subtitle text-muted">
                                            Clique no botão abaixo para criar
                                            sua primeira regra de alerta
                                            personalizada!
                                        </p>
                                        <div class="empty-action">
                                            <a
                                                href="/alert-rules/new"
                                                class="btn btn-primary"
                                            >
                                                <i class="ti ti-plus"></i>
                                                Criar regra de alerta
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="
                                        !alertRulesList.length && filter.query
                                    "
                                    class="card-body"
                                >
                                    <div class="empty bg-muted-lt">
                                        <p class="empty-title">
                                            Nenhuma regra de alerta encontrado
                                            para esta busca.
                                        </p>
                                    </div>
                                </div>

                                <div class="card-footer">
                                    <Pagination
                                        v-if="total"
                                        :key="paginationKey"
                                        :show-per-page="showPerPage"
                                        :current-page="currentPage"
                                        :total="total"
                                        @page-change="updatePage"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../services/event-bus"
import Api from "../services/api"
import { store } from "../store"
import Pagination from "../components/Pagination"
import moment from "moment"

export default {
    name: "AlertRulesPage",
    components: {
        Pagination
    },
    data() {
        return {
            paginationKey: null,
            showPerPage: 10,
            currentPage: 1,
            total: 0,
            alertRulesList: [],
            filter: {
                query: ""
            }
        }
    },
    async mounted() {
        store.showSidebar = true
        store.showHeader = true
        store.showGroupButton = true

        this.currentPage = parseInt(this.$route.query.page) || 1
        this.filter.query = this.$route.query.query || ""
        this.filter.group = localStorage.getItem("selectedGroup") || ""
        this.loadAlertRules()

        EventBus.on("update-selected-group", () => {
            this.filter.group = localStorage.getItem("selectedGroup") || ""
            this.updateFilter()
        })
    },
    methods: {
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY HH:mm:ss")
        },
        async loadAlertRules() {
            this.paginationKey = Math.random()

            var response = await Api.alertRules.list(
                this.currentPage,
                this.showPerPage,
                this.filter
            )

            this.alertRulesList = response.data.items
            this.total = response.data.total
        },
        updateFilter() {
            this.$router.replace({
                query: {
                    page: 1,
                    query: this.filter.query,
                    _: Math.random()
                }
            })
        },

        async duplicateAlertRule(e, alertRule) {
            e.preventDefault()

            if (
                confirm(
                    "Deseja realmente duplicar esta regra de alerta? A cópia será criada desabilitada."
                )
            ) {
                await Api.alertRules.duplicate(alertRule._id)

                EventBus.emit("message", {
                    type: "success",
                    message: "Regra de alerta duplicado com sucesso!"
                })

                this.$router.go()
            }
        },

        updatePage(page) {
            this.currentPage = page
            this.paginationKey = Math.random()

            var queryParams = {
                page: page
            }

            if (this.filter.query) queryParams.query = this.filter.query

            this.$router.replace({
                query: queryParams,
                _: Math.random()
            })
        },

        getActionLabel(value) {
            switch (value) {
                case "email":
                    return "E-mail"
                case "webhook":
                    return "Webhook"
                default:
                    return "Desconhecido"
            }
        },

        getTypeLabel(value) {
            switch (value) {
                case "match_log":
                    return "Match de logs"
                default:
                    return "Desconhecido"
            }
        },

        getTimeWindowLabel(seconds) {
            switch (seconds) {
                case 60:
                    return "1 minuto"
                case 300:
                    return "5 minutos"
                case 600:
                    return "10 minutos"
                case 1800:
                    return "30 minutos"
                case 3600:
                    return "1 hora"
            }

            return ""
        },

        groupName(group_id) {
            if (!group_id) return null

            var group = null
            store.groups.forEach((item) => {
                if (item._id == group_id) {
                    group = item
                }
            })

            return group ? group.name : null
        }
    }
}
</script>
